var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeOn = function SvgEyeOn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    fill: "none",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 7.501c0 1.667-2.917 5.834-7.5 5.834S1.5 9.168 1.5 7.5c0-1.666 2.917-5.833 7.5-5.833s7.5 4.167 7.5 5.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.5 7.501a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOn);
export default ForwardRef;